import { Check } from "lucide-react";
import { APPOINTMENT_TYPE_OPTIONS } from "../lib/clinicalOptions";

export const AppointmentTypeSelect = ({ value = [], onChange, testId = "appointment-types" }) => {
  const selected = Array.isArray(value) ? value : [];
  const toggle = (option) => {
    onChange(selected.includes(option)
      ? selected.filter((item) => item !== option)
      : [...selected, option]);
  };

  return (
    <div className="grid grid-cols-2 gap-2" data-testid={testId}>
      {APPOINTMENT_TYPE_OPTIONS.map((option) => {
        const active = selected.includes(option);
        return (
          <button
            key={option}
            type="button"
            onClick={() => toggle(option)}
            aria-pressed={active}
            className={"flex h-10 items-center justify-between rounded-md border px-3 text-sm transition-colors " + (active ? "border-primary bg-sky-50 font-medium text-primary" : "border-slate-200 bg-white text-slate-600 hover:border-slate-300")}
            data-testid={`${testId}-${option === "Telehealth" ? "telehealth" : "in-person"}`}
          >
            {option}
            <span className={"flex h-4 w-4 items-center justify-center rounded-full border " + (active ? "border-primary bg-primary text-white" : "border-slate-300")}>
              {active && <Check className="h-3 w-3" />}
            </span>
          </button>
        );
      })}
    </div>
  );
};
